import React, { useState } from "react";
import FormatDate from "go-core/components/Formatters/FormatDate";
import { ReportComboDateUtils } from "../../../services/comboSimpleDateUtils";

function getWeeksFromEndDate(
	endDate: Date,
	limit: number
): {
	week: string;
	id: string;
	from: Date;
	to: Date;
	name: string;
}[] {
	const result: {
		week: string;
		id: string;
		from: Date;
		to: Date;
		name: string;
	}[] = [];

	const weekInfo = ReportComboDateUtils.getISOWeekInfo(endDate);
	const datesWeekInfo = ReportComboDateUtils.getISOWeekRange(weekInfo.year, weekInfo.week);

	for (let i = 0; i < limit; i++) {
		const from = new Date(datesWeekInfo.from);
		from.setDate(from.getDate() - (limit - 1 - i) * 7);

		const to = new Date(from);
		to.setDate(to.getDate() + 6);
		to.setHours(23, 59, 59, 999);

		const weekInfo1 = ReportComboDateUtils.getNumberOfWeek(from, 0);
		const isoWeek = weekInfo1.week;
		const year = weekInfo1.year;

		result.push({
			week: `week_${i + 1}`,
			id: `previous_${limit - i - 1}_weeks`,
			from: from,
			to: to,
			name: `Week ${year} ${isoWeek}`,
		});
	}

	return result.reverse();
}

interface Props {
	name: string;
	filter?: Record<string, string>;
	onChange: (value: Record<string, string>) => void;
}

export const WeekReportCombo = (props: Props) => {
	const [value, setValue] = useState<string | undefined>(props.filter ? props.filter[props.name] : undefined);
	const weeks = getWeeksFromEndDate(new Date(), 30);

	const onChange = (newValue: string) => {
		const filterQuarter = weeks.filter((x) => x.id === newValue)[0];
		setValue(filterQuarter.id);
		const parserFilters: Record<string, any> = {
			[props.name]: `${filterQuarter.id}`,
		};

		props.onChange(parserFilters);
	};
	return (
		<div className="content-navigation">
			<div role="group" className="me-2 text-nowrap flex-wrap dashboard-filters-buttons btn-group">
				{weeks.map((week) => {
					return (
						<button
							type="button"
							onClick={() => onChange(week.id)}
							className={`btn${value && week.id === value ? " btn-primary" : " btn-default"}`}
							key={week.id}
						>
							{week.name}
							<small>
								<br />({FormatDate(week.from, undefined, undefined, { hours: "none" })} -{" "}
								{FormatDate(week.to, undefined, undefined, { hours: "none" })})
							</small>
						</button>
					);
				})}
			</div>
		</div>
	);
};
